import React, { useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const location = useLocation();
    const navbarCollapseRef = useRef(null);

    const isActive = (path) => location.pathname === path;

    const handleNavClick = () => {
        // Collapse the navbar manually (for mobile)
        const navbar = navbarCollapseRef.current;
        if (navbar && navbar.classList.contains('show')) {
            navbar.classList.remove('show');
            const toggler = document.querySelector('.navbar-toggler');
            if (toggler) toggler.setAttribute('aria-expanded', 'false');
        }
    };

    return (
        <nav className="navbar navbar-expand-lg bg-white navbar-light fixed-top shadow py-lg-0 px-4 px-lg-5 wow fadeIn"
            data-wow-delay="0.1s"
            style={{
                visibility: "visible",
                animationDelay: "0.1s",
                animationName: "fadeIn",
                display: "flex"
            }}
        >
            <Link to="/" className="navbar-brand d-block d-lg-none">
                <h1 className="text-primary">ProArt</h1>
                <h6 className="text-primary text-center">Digital Studio</h6>
            </Link>
            <button
                type="button"
                className="navbar-toggler"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
            >
                <span className="navbar-toggler-icon" />
            </button>
            <div
                className="collapse navbar-collapse justify-content-between py-4 py-lg-0"
                id="navbarCollapse"
                ref={navbarCollapseRef}
            >
                <div className="navbar-nav ms-auto py-0">
                    <Link to="/" className={`nav-item nav-link ${isActive('/') ? 'active' : ''}`} onClick={handleNavClick}>
                        Home
                    </Link>
                    <Link to="/about" className={`nav-item nav-link ${isActive('/about') ? 'active' : ''}`} onClick={handleNavClick}>
                        About
                    </Link>
                    <Link to="/service" className={`nav-item nav-link ${isActive('/service') ? 'active' : ''}`} onClick={handleNavClick}>
                        Services
                    </Link>
                </div>
                <Link
                    to="/"
                    className="navbar-brand bg-primary px-4 mx-3 d-none d-lg-block"
                >
                    <h1 className="text-white m-auto">ProArt</h1>
                    <h6 className="text-white text-center">Digital Studio</h6>
                </Link>
                <div className="navbar-nav me-auto py-0">
                    <Link to="/product" className={`nav-item nav-link ${isActive('/product') ? 'active' : ''}`} onClick={handleNavClick}>
                        Projects
                    </Link>
                    <Link to="/team" className={`nav-item nav-link ${isActive('/team') ? 'active' : ''}`} onClick={handleNavClick}>
                        Our Team
                    </Link>
                    <Link to="/contact" className={`nav-item nav-link ${isActive('/contact') ? 'active' : ''}`} onClick={handleNavClick}>
                        Contact
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default Header;
